<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="9.79" height="16.942" viewBox="0 0 9.79 16.942">
    <g id="Gruppe_41" data-name="Gruppe 41" transform="translate(-502.316 -212.27)">
      <line id="Linie_8" data-name="Linie 8" x1="7.896" y2="8.422" transform="translate(503.263 220.106)" fill="none" stroke="#3a3844" stroke-width="2"/>
      <line id="Linie_9" data-name="Linie 9" x1="7.896" y2="8.422" transform="translate(511.422 213) rotate(90)" fill="none" stroke="#3a3844" stroke-width="2"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "chevron_right"
}
</script>

<style scoped>

</style>